import script from "./nextMune.vue?vue&type=script&setup=true&lang=js"
export * from "./nextMune.vue?vue&type=script&setup=true&lang=js"

import "./nextMune.vue?vue&type=style&index=0&id=5a89b950&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a89b950"]])

export default __exports__